import { SchemaType } from '../type';
export const schema = {
    id: 'xy_flow',
    name: get => `工作流（${get('name')}）`,
    type: SchemaType.Indivisible,
};
